<template>
  <div class="bg-white shadow p-3">
    <slot></slot>
  </div>
</template>
